import React from 'react';
import { Hash, Lock } from 'lucide-react';

const TIER_LABELS = { free: 'Free', bronze: 'Bronze', silver: 'Silver', gold: 'Gold' };

export const RoomList = ({ rooms, selectedId, onSelect, horizontal = false }) => (
  <div className={horizontal
    ? 'flex gap-1 px-2 py-2 overflow-x-auto border-b border-zinc-800/80 bg-[#0a0a0c] shrink-0'
    : 'w-64 flex-shrink-0 border-r border-zinc-800/80 bg-[#0a0a0c] overflow-y-auto p-2'} data-testid="chat-room-list">
    {!horizontal && <p className="font-typewriter text-[10px] tracking-widest text-zinc-500 px-3 py-2 uppercase">Channels</p>}
    {rooms.map((room) => {
      const active = room.id === selectedId;
      return (
        <button key={room.id} onClick={() => onSelect(room)} data-testid={`chat-room-item-${room.id}`}
          className={`${horizontal ? 'shrink-0' : 'w-full mb-0.5'} flex items-center justify-between gap-2 px-3 py-2.5 rounded-md text-sm transition-colors duration-150 border-l-2 ${active ? 'bg-zinc-800/70 text-amber-500 font-medium border-amber-500' : 'text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800/40 border-transparent'}`}>
          <span className="flex items-center gap-1.5 min-w-0">
            <Hash className="w-4 h-4 flex-shrink-0" />
            <span className="truncate">{room.name}</span>
            {room.minTier !== 'free' && <Lock className="w-3.5 h-3.5 text-zinc-500 flex-shrink-0" title={`${TIER_LABELS[room.minTier]}+`} />}
          </span>
          {room.unreadCount > 0 && (
            <span className="bg-amber-600/30 text-amber-400 font-mono text-[10px] px-1.5 py-0.5 rounded-md border border-amber-500/40" data-testid={`room-unread-${room.id}`}>
              {room.unreadCount > 99 ? '99+' : room.unreadCount}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

export default RoomList;
